import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './style.scss';
import PropTypes from 'prop-types';
import { notification, Switch } from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3FormInput from '@Uilib/h3FormInput';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';

/**
 * UpdateSequenceForm component
 *
 * @param file
 */
class UpdateSequenceForm extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  /**
   * @param props
   * @param state
   */
  static getDerivedStateFromProps(props, state) {
    if (props?.sequenceData && !state?.sequenceData) {
      return {
        sequenceData: props?.sequenceData,
        ...state,
      };
    }
    return state;
  }

  /**
   *
   */
  updateDocumentNumber() {
    this.setState({ formSubmitted: true });
    const { sequenceData } = this.state;
    const { updatePoSequence, user, callback } = this.props;
    const payload = {};
    payload[sequenceData?.prefixKey] = sequenceData.prefix;
    payload[sequenceData?.sqnKey] = sequenceData.sqn;
    payload.tenant_id = user?.tenant_info?.tenant_id;
    if (sequenceData.prefix && sequenceData.sqn >= 0) {
      if (this.props.sequenceData?.prefix === sequenceData?.prefix && this.props.sequenceData?.sqn > sequenceData.sqn) {
        notification.open({
          type: 'error',
          message: `New sequence number cannot less than ${this.props.sequenceData?.sqn}`,
          duration: 4,
          placement: 'top',
        });
      } else {
        updatePoSequence(payload, () => {
          callback();
          this.setState({ formSubmitted: false });
        });
      }
    }
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      updatePoSequenceLoading,
    } = this.props;
    const { sequenceData, formSubmitted } = this.state;
    return (
      <Fragment>
        <div className="ant-row">
          <div className="ant-col-md-24">
            <H3FormInput
              name="prefix"
              type="text"
              containerClassName="orgInputContainer update-uom-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => {
                const sqnData = JSON.parse(JSON.stringify(sequenceData));
                sqnData.prefix = event.target.value;
                this.setState({ sequenceData: sqnData });
              }}
              value={sequenceData?.prefix}
              showError={formSubmitted && !sequenceData?.prefix}
              label="Document Prefix"
              maxlength="100"
              required
              disabled={updatePoSequenceLoading}
            />
            <H3FormInput
              name="sequence number"
              type="number"
              containerClassName="orgInputContainer update-uom-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => {
                const sqnData = JSON.parse(JSON.stringify(sequenceData));
                sqnData.sqn = event.target.value;
                this.setState({ sequenceData: sqnData });
              }}
              value={sequenceData?.sqn}
              showError={formSubmitted && Number(sequenceData?.sqn) < 0}
              label="Current Sequence"
              maxlength="100"
              required
              disabled={updatePoSequenceLoading}
              noDecimal
            />
          </div>
        </div>
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6">
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text="Save"
              onClick={() => this.updateDocumentNumber()}
              isLoading={updatePoSequenceLoading}
              disabled={updatePoSequenceLoading}
              style={{
                width: '100px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers, PurchaseOrderReducers }) => ({
  user: UserReducers.user,
  updatePoSequenceLoading: PurchaseOrderReducers.updatePoSequenceLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updatePoSequence: (payload, callback) => dispatch(PurchaseOrderActions.updatePoSequence(payload, callback)),
});

UpdateSequenceForm.propTypes = {
  updatePoSequenceLoading: PropTypes.bool,
  updatePoSequence: PropTypes.func,
  callback: PropTypes.any,
  user: PropTypes.any,
  sequenceData: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdateSequenceForm));
